import { getTranslations } from 'helpers/i18n'
import { TRANSLATIONS_GET } from 'reducers/i18n'

export default {
  getTranslations: (params) => ({
    type: TRANSLATIONS_GET,
    payload: getTranslations(params),
  }),
}
